<template>
    
    <div class="container-fse">

        <div class="option-fse">

            <span @click="handleClick" class="parametre-item selected-parametre-item">Détails</span>
            <span @click="affichePatient" :class="{ 'pressed': isPressed }" class="parametre-item">Patient</span>
            <span @click="afficheRegime" :class="{ 'pressed2': isPressed2 }" class="parametre-item">Régime Spéciaux</span>
            <span @click="afficheDivers" :class="{ 'pressed3': isPressed3 }" class="parametre-item">Divers</span>
            <span @click="afficheFacture" :class="{ 'pressed5': isPressed5 }" class="parametre-item">Facture</span>
            <span @click="affichePraticien" :class="{ 'pressed4': isPressed4 }" class="parametre-item">Praticien</span>

        </div>
        <div class="centered-interface">
            <h1>Feuille de soins du médecin</h1>
            <div class="main-container--médecin-fse">
                <p>medecin</p>
                <p>patient</p>
                <div class="component-medecin-Fse">
                    <h2>{{ nomPrenom }}</h2>
                    <h3>{{ cabinet }}</h3>
                    <label>//TODO 99 14611 9 0 20 01</label>
                </div>
                <div class="component-medecin-Fse">
                    <h2 v-if="benefList[getIndexBenefActif] != undefined">Nom    : {{ benefList[getIndexBenefActif].nom}}</h2>
                    <h2 v-if="benefList[getIndexBenefActif] != undefined">Prénom : {{ benefList[getIndexBenefActif].prenom}}</h2>
                    <!--<label>99 14611 9 0 20 01</label>-->
                </div>

            </div>
            <div class="container-acte-Fse">
                <p>Acte</p>

                <div class="component-acte-Fse" v-for="(numeroDActe, index) in nombreDActes" :key="numeroDActe">

                    <button>{{numeroDActe}}</button>

                    <input type="text" v-model="dateSaisie[index]" placeholder="JJ/MM/AAAA" v-date-fr />

                    <div class="dropdown">
                        <input class="dropdown-input"
                               @focus="showOptions(index)"
                               @blur="exit(index)"
                               @keyup="keyMonitor($event, index)"
                               v-model="searchFilter[index]"
                               :placeholder="placeholder"
                               :style="{ color: isSuccessful[index] ? 'green' : 'red' }" />

                        <div class="dropdown-content"
                             ref="dropdownMenu"
                             v-show="optionsShown[index]">
                            <div class="dropdown-item"
                                 :class="{ highlighted: i === highlightedOption[index] }"
                                 @mousedown="selectOption(option, index)"
                                 v-for="(option, i) in filteredOptions[index]"
                                 :key="i">
                                {{ option.Libelle }}
                            </div>
                        </div>
                    </div>

                    <!-- ---------------------------------------------------------------------------------------------- -->

                    <button v-if="nombreDActes.length !== 1" class="acte-button" @click="decrNombreDActe(index)" style="background-color:orange">-</button>
                    <!--<button v-if="index === nombreDActes.length - 1" class="acte-button" @click="incrNombreDActe"> Ajouter un acte</button>-->

                </div>
                <button class="add-acte-button" @click="incrNombreDActe"> Ajouter un acte</button>

            </div>



            <div class="container-personne">
                <p class="second">Parcours de soins</p>
                <p class="first"></p>



                <div class="component-parcours">

                    <div class="component-parcours-haut">
                        <label>
                            Je suis le méd. traitant

                        </label>
                        <input type="checkbox" v-model="jeMt" @change="onMtChange('je')" />
                        <label>
                            Autre M.T

                        </label>
                        <input type="checkbox" v-model="autreMt" @change="onMtChange('autre')" />

                        <label>
                            Aucun

                        </label>
                        <input type="checkbox" v-model="aucunMt" @change="onMtChange('aucun')" />
                    </div>

                    <label class="case-Fse">
                        Nom médecin
                        <select v-model="selectedMedecin">
                            <option v-for="medecin in medecins" :value="medecin">{{ medecin }}</option>
                        </select>
                        <input type="text" name="name" value="" />
                    </label>

                    <label class="case-Fse">
                        Parcours
                        <select v-model="selectedParcours" @change="envoyerChoixParcours">
                            <option v-for="parcour in parcours" :value="parcour">{{ parcour }}</option>
                        </select>
                    </label>
                </div>
                <!--<div class="component-personne">

            <label>nom </label><input type="text" name="name" value="" /><br /> <br />
            <label>prénom </label><input type="text" name="name" value="" /><br />
        </div>-->
            </div>
            <div class="container-montant-Fse">
                <p>paiement</p>

                <div class="component-montant-Fse">
                    <label><span>AMO</span><input type="checkbox"></label>
                    <label><span>Mutuelle</span><input type="checkbox"></label>
                    <label><span>Montant total</span><input type="text" name="name" value="option." placeholder="0" @input="filterInput($event, 'montantTotal')" v-model="montantTotal" readonly>€</label>
                    <label><span>Tiers payant</span><input type="text" name="name" value="" placeholder="0" @input="filterInput($event, 'montantTiersPayant')" v-model="montantTiersPayant" readonly>€</label>
                    <label><span>Solde à payer</span><input type="text" name="name" value="" placeholder="0" @input="filterInput($event, 'montantAPayer')" v-model="montantAPayer" />€</label>
                </div>
            </div>
            <div class="listeButton">
                <button><span>Imprimer</span> <div><img src="../images/print.png" alt="Alternate Text" /></div></button>
                <button @click="enregistrer"><span>Enregistrer</span> <div><img src="../images/save.png" alt="Alternate Text" /></div></button>
                <button><span>Paiement</span> <div><img src="../images/paiement.png" alt="Alternate Text" /></div></button>
            </div>
        </div>
        <div class="option-details-patient-fse" id="option-details-patient-fse">
            <h1>Patients : Alias Ali</h1>
            <label>Né(e) le <input type="text" name="name" placeholder="JJ/MM/AAAA" v-date-fr /></label>
            <label><input type="checkbox" name="name" value="" /> Alsace-Moselle</label>
            <div class="border-situation-fse">
                <label>Situation</label>
                <div class="container-situation-fse">

                    <input class="situation-1" type="text" name="name" value="" />
                    <input class="situation-2" type="text" name="name" value="" />
                    <input class="situation-3" type="text" name="name" value="" />
                    <input class="situation-4" type="text" name="name" value="" />

                </div>
            </div>

            <label>Mutuelle/ Complémentaire</label>
            <!-- noadh.Text -->
            <div>
                <label>Numéro <input type="text" name="name" value="" /></label>
            </div>
            <label><input type="checkbox" name="name" value="" />Convention référent</label>
        </div>
        <div class="option-details-regime-fse" id="option-details-regime-fse">
            <h1>Régime spéciaux</h1>
            <label><input type="checkbox" name="name" value="" />Prescription par Médecin SNCF</label>
            <label>
                Mutuelle/ Complémentaire <select v-model="selectedSpe">
                    <option v-for="spe in spes" :value="spe">{{ spe }}</option>
                </select>
            </label>

        </div>
        <div class="option-details-divers-fse" id="option-details-divers-fse">
            <h1>Divers</h1>
            <div class="container-divers">
                <h2>Accident</h2>
                <label><input type="checkbox" name="name" value="" />Accident</label>
                <label><input type="checkbox" name="name" value="" />Accident Travail</label>
            </div>
            <label id="maternite-check-fse"><input id="maternite-checkbox-fse" @change="checkMaternite" type="checkbox" name="name" value="" />Maternité</label>

            <div class="container-divers" id="container-divers-maternite">
                <h2>Maternite</h2>
                <label><input id="maternite-checkbox2-fse" @change="checkMaternite" type="checkbox" name="name" value="" />Maternité</label>
                <label>Date de début grossesse ou acouchement ou adoption <input type="text" name="name" placeholder="JJ/MM/AAAA" v-date-fr /></label>
            </div>
            <label><input type="checkbox" name="name" value="" />Soins médicaux gratuits (SMG)</label>
            <label><input type="checkbox" name="name" value="" />Concerne l'ALD</label>
            <label><input type="checkbox" name="name" value="" />Acte nouveau-né</label>
            <label><input type="checkbox" name="name" value="" />Avance de frais</label>
            <label><input type="checkbox" name="name" value="" />Carnet médical présenté</label>
            <label><input type="checkbox" name="name" value="" />Victime d'Attentat</label>
            <label>
                Origine de la Prescription
                <select v-model="selectedPrescription">
                    <option v-for="prescription in prescriptions" :value="spe">{{ prescription }}</option>
                </select>

            </label>


        </div>
        <div class="option-details-praticien-fse" id="option-details-praticien-fse">
            <h1>Pratitien : Virginie</h1>

            <label>782472687</label>
            <label>003864547</label>

            <label>Medecin RPPS0038645</label>
            <label>Spécialité: 01</label>
            <label>Zone IK : 01</label>
            <label>Zone tarifiaire : 24</label>
            <label>Convention : Conventionné ss dep</label>
        </div>
        <div class="option-details-facture-fse" id="option-details-facture-fse">
            <h1>Facture</h1>
            <div class="container-facture-fse">

                <label>Date <input type="text" name="name" placeholder="JJ/MM/AAAA" v-date-fr /></label>
                <label>Série <input type="checkbox" name="name" value="" /></label>
            </div>

            <div class="container-facture-fse">
                <h2>Tiers payant</h2>
                <div class="component-facture-fse2">
                    <label>Forcer ACS/CMU<input type="checkbox" name="name" value="" /></label>
                    <label>AME<input type="checkbox" name="name" value="" /></label>
                </div>
            </div>
            <div class="container-facture-fse">
                <h2>Lieu execution</h2>
                <div class="component-facture-fse">
                    <label>Cabinet<input type="checkbox" name="name" value="" /></label>
                    <label>Déplacement <input type="text" name="name" value="" /></label>
                </div>
            </div>
            <label>En rapport avec un acte exonérant <input type="checkbox" name="name" value="" /></label>
            <label>Action de prévention <input type="checkbox" name="name" value="" /></label>
            <div class="container-facture-fse">
                <h2>Facture</h2>
                <div class="component-facture-fse">
                    <label>TLA<input type="checkbox" name="name" value="" /></label>


                    <label>Sécurisée <input type="checkbox" name="name" value="" /></label>
                    <label>Sans Vitale <input type="checkbox" name="name" value="" /></label>
                    <label>SS Vitale <input type="checkbox" name="name" value="" /></label>

                    <label>Dre<input type="checkbox" name="name" value="" /></label>
                    <label>Dre ss Fse <input type="checkbox" name="name" value="" /></label>

                </div>



            </div>
            <div class="container-facture-fse">
                <h2>Pièce justificative AMO</h2>
                <div class="component-facture-fse">
                    <label>Nature <input type="text" name="name" value="" /></label>
                    <label>Validité <input type="text" name="name" value="" /></label>
                    <label>Origine <input type="text" name="name" value="" /></label>
                </div>
            </div>
            <div class="container-facture-fse">
                <h2>Mode</h2>
                <div class="component-facture-fse2">
                    <label>Normal<input type="checkbox" name="name" value="" /></label>
                    <label>Désynchronisé <input type="checkbox" name="name" value="" /></label>
                </div>
            </div>

        </div>
        <img @click="afficheToutDivers" class="affiche-mobile-divers" src="../images/more.png" alt="Alternate Text" />
    </div>
</template>


<style scoped>
    * {
        margin: 0;
        padding: 0;
    }

    input {
        background-color: white;
        padding: 5px;
    }

    @keyframes fade-in {
        from {
            /* Fade in from 0 opacity */
        }

        to {
            opacity: 1; /* Fade in to 1 opacity */
        }
    }




    .border-situation-fse {
        border: 1px solid grey;
        padding: 5px;
    }

    .container-situation-fse {
        display: flex;
    }

        .container-situation-fse .situation-1 {
            width: 40px;
        }

        .container-situation-fse .situation-2 {
            width: 40px;
        }

        .container-situation-fse .situation-3 {
            width: 40px;
        }

        .container-situation-fse .situation-4 {
            width: 60px;
        }

        .container-situation-fse input {
            height: 25px;
            margin-right: 2px;
            margin-left: 2px;
        }

            .container-situation-fse input:hover {
                background-color: coral;
            }

    .container-fse {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-gap: 10px;
    }

    .centered-interface {
        display: flex;
        align-items: center;
        flex-direction: column;
        grid-column: 2/3
    }

    .option-fse {
        justify-self: start;
    }

    .parametre-item {
        height: 50px;
        width: 10rem;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

        .parametre-item:hover {
            cursor: pointer;
            background-image: linear-gradient(315deg, #ff4e00 0%, #ec9f05 74%);
            color: white;
        }

    .selected-parametre-item {
        background-image: linear-gradient(315deg, #ff4e00 0%, #ec9f05 74%);
        color: white;
    }


    .pressed {
        cursor: pointer;
        background-image: linear-gradient(315deg, #ff4e00 0%, #ec9f05 74%);
        color: white;
    }

    .pressed2 {
        cursor: pointer;
        background-image: linear-gradient(315deg, #ff4e00 0%, #ec9f05 74%);
        color: white;
    }

    .pressed3 {
        cursor: pointer;
        background-image: linear-gradient(315deg, #ff4e00 0%, #ec9f05 74%);
        color: white;
    }

    .pressed4 {
        cursor: pointer;
        background-image: linear-gradient(315deg, #ff4e00 0%, #ec9f05 74%);
        color: white;
    }

    .pressed5 {
        cursor: pointer;
        background-image: linear-gradient(315deg, #ff4e00 0%, #ec9f05 74%);
        color: white;
    }

    button {
        border: 0;
    }

    .component-acte-Fse .acte-button {
        align-items: center;
        border-radius: 8px;
        background-color: darkorange;
        color: #FFFFFF;
        font-family: Phantomsans, sans-serif;
        font-size: 20px;
        justify-content: center;
        line-height: 1em;
        max-width: 50%;
        min-width: 25px;
        padding: 5px 5px;
        text-decoration: none;
        user-select: none;
        -webkit-user-select: none;
        touch-action: manipulation;
        white-space: nowrap;
        cursor: pointer;
    }

    .add-acte-button {
        align-items: center;
        border-radius: 8px;
        background-color: darkorange;
        color: #FFFFFF;
        font-family: Phantomsans, sans-serif;
        font-size: 16px;
        justify-content: center;
        line-height: 1em;
        max-width: 50%;
        min-width: 25px;
        padding: 5px 5px;
        text-decoration: none;
        user-select: none;
        -webkit-user-select: none;
        touch-action: manipulation;
        white-space: nowrap;
        cursor: pointer;
    }


    .listeButton {
        margin-top: 20px;
        margin-bottom: 5px;
    }

        .listeButton button {
            align-items: center;
            background-clip: padding-box;
            background-color: #fa6400;
            border: 1px solid transparent;
            border-radius: .25rem;
            box-shadow: rgba(0, 0, 0, 0.02) 0 1px 3px 0;
            box-sizing: border-box;
            cursor: pointer;
            display: inline-flex;
            font-family: system-ui, -apple-system, system-ui, "Helvetica Neue", Helvetica, Arial, sans-serif;
            font-size: 16px;
            font-weight: 600;
            line-height: 1.25;
            margin-right: 5px;
            min-height: 3rem;
            padding: calc(.875rem - 1px) calc(1.5rem - 1px);
            position: relative;
            text-decoration: none;
            transition: all 250ms;
            user-select: none;
            -webkit-user-select: none;
            touch-action: manipulation;
            vertical-align: baseline;
            width: 150px;
        }

            .listeButton button:hover,
            .listeButton button:focus {
                background-color: #fb8332;
                box-shadow: rgba(0, 0, 0, 0.1) 0 4px 12px;
            }

            .listeButton button:hover {
                transform: translateY(-1px);
            }

            .listeButton button:active {
                background-color: #c85000;
                box-shadow: rgba(0, 0, 0, .06) 0 2px 4px;
                transform: translateY(0);
            }

        .listeButton span {
            color: white;
        }

        .listeButton div {
            display: inline-block;
            margin-left: 0.5rem;
        }

        .listeButton img {
            height: 1.25rem; /* Adjust the height as needed */
            width: auto; /* Maintain aspect ratio */
        }

    .container-montant-Fse {
        background-color: #ffe3e3;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
    }

        .container-montant-Fse p {
            width: 850px;
        }

    .container-acte-Fse {
        background-color: #ffe3e3;
    }

        .container-acte-Fse p {
            width: 850px;
        }



    .component-acte-Fse {
        margin-top: 15px;
        margin-bottom: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

        .component-acte-Fse input {
            margin-top: 20px;
            width: 140px;
            padding: 5px;
            margin: 5px;
        }

    .component-montant-Fse {
        display: flex;
        margin-top: 10px;
        align-items: center;
        max-width: 850px;
    }

        .component-montant-Fse label {
            display: flex;
            align-items: center;
            margin-right: 10px; /* Ajustez la valeur selon votre préférence */
        }

        .component-montant-Fse span {
            margin-right: 5px;
        }

        .component-montant-Fse input[type="text"] {
            width: 20%;
            padding: 5px;
        }

    .component-acte-Fse button {
        margin: 5px;
        width: 35px;
        font-size: 15px;
        border-radius: 20px;
        background-color: darkorange;
        color: white;
        padding: 5px;
    }

    input {
        height: 30px;
        border: 0.2px solid #DCDCDC;
    }

    .container-personne p {
        width: 424.5px;
        margin-right: 1px;
    }

    .main-container--médecin-fse p {
        width: 424.5px;
        margin-right: 1px;
    }

    p {
        padding: 2px;
        padding-left: 8px;
        height: 28px;
        color: white;
        background-color: orangered;
        margin-bottom: 0px;
    }

    .main-container--médecin-fse {
        width: 850px;
        padding-bottom: 100px;
        display: grid;
        grid-template-columns: 1fr 1fr;
    }

    .component-medecin-Fse {
        margin: 5px;
    }

        .component-medecin-Fse h2 {
            font-size: 25px;
        }

        .component-medecin-Fse h3 {
            font-size: 20px;
        }

        .component-medecin-Fse label {
            font-size: 15px;
        }

    .container-médecin-fse {
        display: grid;
        grid-template-columns: 1fr 1fr;
    }

    .component-style-Fse {
        background-color: #ffe3e3;
        width: 425px;
    }

    .container-personne {
        width: 850px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        background-color: #ffe3e3
    }

    .component-parcours {
        display: flex;
        flex-direction: column;
        margin: 5px;
    }



    .component-parcours-haut {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }

        .component-parcours-haut label:nth-child(2n+1) {
            margin-top: 2px;
        }

    .component-personne label {
        display: block;
        margin-bottom: 10px;
    }

    .option-details-patient-fse input[type="date"],
    .option-details-patient-fse input[type="text"] {
        padding: 5px;
        border: 1px solid #E17055;
        border-radius: 5px;
    }

    .option-details-patient-fse input[type=checkbox], input[type=radio] {
        vertical-align: middle;
        position: relative;
        bottom: 1px;
    }

    .option-details-patient-fse input[type="checkbox"] {
        margin: 0;
        appearance: none;
        width: 16px;
        height: 16px;
        border: 2px solid #E17055;
        border-radius: 4px;
        background-color: #FDF3E7;
        cursor: pointer;
        margin-right: 5px;
    }

        .option-details-patient-fse input[type="checkbox"]:checked {
            background-color: orangered;
        }

        .option-details-patient-fse input[type="checkbox"] + label {
            margin-left: 5px;
        }

    .option-details-patient-fse {
        /* Start with 0 opacity */
        animation: fade-in 1s ease-in-out forwards; /* Animation properties */
        margin-right: 10px;
    }

    .option-details-regime-fse {
        /* Start with 0 opacity */
        animation: fade-in 1s ease-in-out forwards; /* Animation properties */
        margin-right: 10px;
    }

    .option-details-divers-fse {
        /* Start with 0 opacity */
        animation: fade-in 1s ease-in-out forwards; /* Animation properties */
        margin-right: 10px;
    }

    .option-details-facture-fse {
        /* Start with 0 opacity */
        animation: fade-in 1s ease-in-out forwards; /* Animation properties */
        margin-right: 10px;
    }



    .option-details-regime-fse {
        display: none;
        background-color: #FDF3E7;
        padding: 20px;
        border-radius: 10px;
    }

    .option-details-divers-fse {
        display: none;
        background-color: #FDF3E7;
        padding: 20px;
        border-radius: 10px;
    }

        .option-details-divers-fse h1 {
            font-size: 24px;
            color: #E17055;
            margin-bottom: 10px;
        }

        .option-details-divers-fse label {
            display: block;
            margin-bottom: 10px;
        }

        .option-details-divers-fse input[type="text"] {
            padding: 5px;
            border: 1px solid #E17055;
            border-radius: 5px;
        }

    h2 {
        font-size: 25px;
        margin-top: 0;
        margin-bottom: 10px;
        font-family: Larsseit-Bold,sans-serif;
    }



    @media screen and (max-width: 900px) {
        .affiche-mobile-divers {
            display: block;
        }

        .affiche-mobile-divers {
            display: block;
            position: fixed;
            right: 0;
        }

        .affiche-mobile-divers {
            left: 10px;
            z-index: 10000;
        }

        .option-details-divers-fse input[type="checkbox"] {
            margin: 0;
            appearance: none;
            width: 16px;
            height: 16px;
            border: 2px solid #E17055;
            border-radius: 4px;
            background-color: #FDF3E7;
            cursor: pointer;
            margin-right: 5px;
        }

            .option-details-divers-fse input[type="checkbox"]:checked {
                background-color: orangered;
            }

            .option-details-divers-fse input[type="checkbox"] + label {
                margin-left: 5px;
            }

        .option-details-facture-fse {
            display: none;
        }


        .option-details-facture-fse {
            background-color: #FDF3E7;
            padding: 20px;
            border-radius: 10px;
            display: none;
        }

            .option-details-facture-fse h1 {
                font-size: 24px;
                color: #E17055;
                margin-bottom: 10px;
            }

            .option-details-facture-fse label {
                display: block;
                margin-bottom: 10px;
            }

            .option-details-facture-fse input[type="date"],
            .option-details-facture-fse input[type="text"] {
                padding: 5px;
                border: 1px solid #E17055;
                border-radius: 5px;
            }

            .option-details-facture-fse input[type=checkbox], input[type=radio] {
                vertical-align: middle;
                position: relative;
                bottom: 1px;
            }

            .option-details-facture-fse input[type="checkbox"] {
                appearance: none;
                width: 16px;
                height: 16px;
                border: 2px solid #E17055;
                border-radius: 4px;
                background-color: #FDF3E7;
                cursor: pointer;
                margin-left: 5px;
            }

                .option-details-facture-fse input[type="checkbox"]:checked {
                    background-color: orangered;
                }

                .option-details-facture-fse input[type="checkbox"] + label {
                    margin-left: 5px;
                }
    }
</style>
<style>
    * {
        margin: 0;
        padding: 0;
    }

    input {
        background-color: white;
        padding: 5px;
    }
</style>
<style scoped>
    .border-situation-fse {
        border: 1px solid grey;
        padding: 5px;
    }

    .container-situation-fse {
        display: flex;
    }

        .container-situation-fse .situation-1 {
            width: 40px;
        }

        .container-situation-fse .situation-2 {
            width: 40px;
        }

    #container-divers-maternite {
        margin-top: 10px;
    }

    .container-situation-fse .situation-3 {
        width: 40px;
    }

    .container-situation-fse .situation-4 {
        width: 60px;
    }

    .container-situation-fse input {
        height: 25px;
        margin-right: 2px;
        margin-left: 2px;
    }

        .container-situation-fse input:hover {
            background-color: coral;
        }

    .option-details-patient-fse {
        background-color: #FDF3E7;
        padding: 20px;
        border-radius: 10px;
        display: none;
    }

        .option-details-patient-fse h1 {
            font-size: 24px;
            color: #E17055;
            margin-bottom: 10px;
        }

        .option-details-patient-fse label {
            display: block;
            margin-bottom: 10px;
        }

        .option-details-patient-fse input[type="date"],
        .option-details-patient-fse input[type="text"] {
            padding: 5px;
            border: 1px solid #E17055;
            border-radius: 5px;
        }

        .option-details-patient-fse input[type=checkbox], input[type=radio] {
            vertical-align: middle;
            position: relative;
            bottom: 1px;
        }

        .option-details-patient-fse input[type="checkbox"] {
            margin: 0;
            appearance: none;
            width: 16px;
            height: 16px;
            border: 2px solid #E17055;
            border-radius: 4px;
            background-color: #FDF3E7;
            cursor: pointer;
            margin-right: 5px;
        }

            .option-details-patient-fse input[type="checkbox"]:checked {
                background-color: orangered;
            }

            .option-details-patient-fse input[type="checkbox"] + label {
                margin-left: 5px;
            }

    .option-details-patient-fse {
        /* Start with 0 opacity */
        animation: fade-in 1s ease-in-out forwards; /* Animation properties */
        margin-right: 10px;
    }

    .option-details-regime-fse {
        /* Start with 0 opacity */
        animation: fade-in 1s ease-in-out forwards; /* Animation properties */
        margin-right: 10px;
    }

    .option-details-divers-fse {
        /* Start with 0 opacity */
        animation: fade-in 1s ease-in-out forwards; /* Animation properties */
        margin-right: 10px;
    }

    .option-details-facture-fse {
        /* Start with 0 opacity */
        animation: fade-in 1s ease-in-out forwards; /* Animation properties */
        margin-right: 10px;
    }



    .option-details-regime-fse {
        display: none;
        background-color: #FDF3E7;
        padding: 20px;
        border-radius: 10px;
    }

        .option-details-regime-fse h1 {
            font-size: 24px;
            color: #E17055;
            margin-bottom: 10px;
        }

        .option-details-regime-fse label {
            display: block;
            width: 130px;
            float: left;
        }

    .component-parcours input {
        margin-left: 5px;
        height: 30px;
    }

    .component-personne {
        margin-left: 5px;
    }

    h1 {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 20px;
        text-align: center;
    }

    .component-parcours label:nth-child(2) input {
        width: 45.5%;
        height: 35px;
    }

    .component-parcours label:nth-child(3) select {
        margin-left: 35px;
        width: 76%
    }

    .component-parcours label:nth-child(2) select {
        width: 28%;
        height: 35px;
    }

    input[type="text"],
    select {
        padding: 5px;
        border: 1px solid #ccc;
        border-radius: 3px;
        background-color: white;
    }

    @media screen and (max-width: 900px) {
        .affiche-mobile-divers {
            display: block;
        }
    }

    .affiche-mobile-divers {
        display: none;
    }

    .option-details-regime-fse {
        display: none;
        background-color: #FDF3E7;
        padding: 20px;
        border-radius: 10px;
    }

        .option-details-regime-fse h1 {
            font-size: 24px;
            color: #E17055;
            margin-bottom: 10px;
        }

        .option-details-regime-fse label {
            display: block;
            margin-bottom: 10px;
        }

        .option-details-regime-fse input[type="text"] {
            padding: 5px;
            border: 1px solid #E17055;
            border-radius: 5px;
        }

    #container-divers-maternite {
        display: none;
    }

    .option-details-regime-fse input[type=checkbox] {
        vertical-align: middle;
        position: relative;
        bottom: 1px;
    }

    .option-details-regime-fse select {
        width: 50%;
    }

    .option-details-regime-fse input[type="checkbox"] {
        margin: 0;
        appearance: none;
        width: 16px;
        height: 16px;
        border: 2px solid #E17055;
        border-radius: 4px;
        background-color: #FDF3E7;
        cursor: pointer;
        margin-right: 5px;
    }

        .option-details-regime-fse input[type="checkbox"]:checked {
            background-color: orangered;
        }

        .option-details-regime-fse input[type="checkbox"] + label {
            margin-left: 5px;
        }

    .container-divers {
        border: 1px solid grey;
        padding: 10px;
    }

    .container-facture-fse {
        border: 1px solid grey;
        padding: 10px;
    }

    .component-facture-fse {
        display: flex;
        justify-content: space-between
    }

    .container-facture-fse h2 {
        border: 1px solid grey;
        padding: 10px;
    }

    h2 {
        font-size: 25px;
        margin-top: 0;
        margin-bottom: 10px;
        font-family: Larsseit-Bold,sans-serif;
    }

    #container-divers-maternite {
        margin-top: 10px;
    }
    /*.container-divers h2{
        color:black;
        font-family:Arial;
        font-size:20px;

    }*/
    .option-details-divers-fse {
        display: none;
        background-color: #FDF3E7;
        padding: 20px;
        border-radius: 10px;
    }

        .option-details-divers-fse h1 {
            font-size: 24px;
            color: #E17055;
            margin-bottom: 10px;
        }

        .option-details-divers-fse label {
            display: block;
            margin-bottom: 10px;
        }


        .option-details-divers-fse input[type="text"] {
            padding: 5px;
            border: 1px solid #E17055;
            border-radius: 5px;
        }

        .option-details-divers-fse input[type=checkbox] {
            vertical-align: middle;
            position: relative;
            bottom: 1px;
        }

        .option-details-divers-fse select {
            width: 50%;
        }

        .option-details-divers-fse input[type="checkbox"] {
            margin: 0;
            appearance: none;
            width: 16px;
            height: 16px;
            border: 2px solid #E17055;
            border-radius: 4px;
            background-color: #FDF3E7;
            cursor: pointer;
            margin-right: 5px;
        }

            .option-details-divers-fse input[type="checkbox"]:checked {
                background-color: orangered;
            }

            .option-details-divers-fse input[type="checkbox"] + label {
                margin-left: 5px;
            }

    .option-details-facture-fse {
        display: none;
    }

    .option-details-praticien-fse {
        background-color: #FDF3E7;
        padding: 20px;
        border-radius: 10px;
        display: none;
    }

        .option-details-praticien-fse h1 {
            font-size: 24px;
            color: #E17055;
            margin-bottom: 10px;
        }

        .option-details-praticien-fse label {
            display: block;
            margin-bottom: 10px;
        }

    .option-details-facture-fse {
        background-color: #FDF3E7;
        padding: 20px;
        border-radius: 10px;
        display: none;
    }

        .option-details-facture-fse h1 {
            font-size: 24px;
            color: #E17055;
            margin-bottom: 10px;
        }

        .option-details-facture-fse label {
            display: block;
            margin-bottom: 10px;
        }

        .option-details-facture-fse input[type="date"],
        .option-details-facture-fse input[type="text"] {
            padding: 5px;
            border: 1px solid #E17055;
            border-radius: 5px;
        }

        .option-details-facture-fse input[type=checkbox], input[type=radio] {
            vertical-align: middle;
            position: relative;
            bottom: 1px;
        }

        .option-details-facture-fse input[type="checkbox"] {
            appearance: none;
            width: 16px;
            height: 16px;
            border: 2px solid #E17055;
            border-radius: 4px;
            background-color: #FDF3E7;
            cursor: pointer;
            margin-left: 5px;
        }

            .option-details-facture-fse input[type="checkbox"]:checked {
                background-color: orangered;
            }

            .option-details-facture-fse input[type="checkbox"] + label {
                margin-left: 5px;
            }

    .option-details-patient-fse {
        background-color: #FDF3E7;
        padding: 20px;
        border-radius: 10px;
        display: none;
    }

        .option-details-patient-fse h1 {
            font-size: 24px;
            color: #E17055;
            margin-bottom: 10px;
        }

        .option-details-patient-fse label {
            display: block;
            margin-bottom: 10px;
        }

        .option-details-patient-fse input[type="date"],
        .option-details-patient-fse input[type="text"] {
            padding: 5px;
            border: 1px solid #E17055;
            border-radius: 5px;
        }

        .option-details-patient-fse input[type=checkbox], input[type=radio] {
            vertical-align: middle;
            position: relative;
            bottom: 1px;
        }

        .option-details-patient-fse input[type="checkbox"] {
            margin: 0;
            appearance: none;
            width: 16px;
            height: 16px;
            border: 2px solid #E17055;
            border-radius: 4px;
            background-color: #FDF3E7;
            cursor: pointer;
            margin-right: 5px;
        }

            .option-details-patient-fse input[type="checkbox"]:checked {
                background-color: orangered;
            }

            .option-details-patient-fse input[type="checkbox"] + label {
                margin-left: 5px;
            }

    .option-details-patient-fse {
        /* Start with 0 opacity */
        animation: fade-in 1s ease-in-out forwards; /* Animation properties */
        margin-right: 10px;
    }

    .option-details-regime-fse {
        /* Start with 0 opacity */
        animation: fade-in 1s ease-in-out forwards; /* Animation properties */
        margin-right: 10px;
    }

    .option-details-divers-fse {
        /* Start with 0 opacity */
        animation: fade-in 1s ease-in-out forwards; /* Animation properties */
        margin-right: 10px;
    }

    .option-details-facture-fse {
        /* Start with 0 opacity */
        animation: fade-in 1s ease-in-out forwards; /* Animation properties */
        margin-right: 10px;
    }

    .option-details-praticien-fse {
        /* Start with 0 opacity */
        animation: fade-in 1s ease-in-out forwards; /* Animation properties */
        margin-right: 10px;
    }

    /* ------------------------------------------------------------------------------------- */

    .dropdown {
        position: relative;
        display: block;
        margin: auto;
    }

    .dropdown-input {
        background: #fff;
        cursor: pointer;
        border: 1px solid #e7ecf5;
        border-radius: 3px;
        color: #333;
        display: block;
        font-size: .8em;
        padding: 6px;
        min-width: 250px;
        max-width: 250px;
        &:hover

    {
        background: #f8f8fa;
    }

    }

    .dropdown-content {
        position: absolute;
        background-color: #fff;
        min-width: 248px;
        max-width: 248px;
        max-height: 248px;
        border: 1px solid #e7ecf5;
        box-shadow: 0px -8px 34px 0px rgba(0,0,0,0.05);
        overflow-y: auto;
        z-index: 1;
    }

    .dropdown-item {
        color: black;
        font-size: .7em;
        line-height: 1em;
        padding: 8px;
        text-decoration: none;
        display: block;
        cursor: pointer;
        &:hover

    {
        background-color: #e7ecf5;
    }

    .dropdown:hover .dropdowncontent {
        display: block;
    }

    .highlighted {
        background-color: #e7ecf5;
    }

    /* ------------------------------------------------------------------------------------- */
    }
</style>

<script>
    import { defineComponent } from 'vue';
    import RequestManager from '../script/request.js';
    import config from '../config.js';
    import Formsoin from '../script/TransCAM/Forms/Formsoin.js'
    import ParcoursDeSoin from '../script/TransCAM/ParcoursDeSoin.js'
    import { mapActions } from "vuex";
    import { mapGetters } from "vuex";
    import { champ, CPS_RAISON_SOCIALE_STRUCTURE, CPS_IDENT_FACTURATION } from '@/script/champsCPS';

    export default defineComponent({
        data() {
            return {
                facfse : null,
                selectedMedecin: '',
                medecins: ['Option 1', 'Option 2', 'Option 3'],
                parcours: [],                  // options réelles fournies par le backend
                selectedParcours: '',
                // Cases "médecin traitant" du panneau parcours
                jeMt: false,
                autreMt: false,
                aucunMt: false,
                isPressed: false,
                isPressed2: false,
                isPressed3: false,
                isPressed4: false,
                isPressed5: false,
                spes: ['Option 1', 'Option 2', 'Option 3'],
                selectedSpe: '',
                prescriptions: ['Option 1', 'Option 2', 'Option 3'],
                selectedPrescription: '',
                // --- Actes ---
                nombreDActes: [1],
                dateSaisie: [''],              // <= sera initialisé à aujourd'hui en created()
                options: [],
                placeholder: 'Please select an option',
                selected: [{}],
                optionsShown: [false],
                searchFilter: [''],
                isSuccessful: [false],
                highlightedOption: [-1],
                // --- Montants ---
                montantTotal: '',
                montantTiersPayant: '',
                montantAPayer: '0',
                lesBeneficiares : []
            };
        },

        computed: {
            ...mapGetters("FSEHandler", ["getFacfse"]),
            ...mapGetters("Cartes", ["getCarteCPS"]),
            ...mapGetters("SSV", ["getCarteVitale", "getIndexBenefActif"]),
            enumCarteVitale() {
                return this.$store.getters['SSV/getStructures_publiques_cartevitale'];
            },
            //...mapGetters("ChoixBenecStore", ["getChoixBenec"]),
            benefList() {
                const list = [];
                if (this.getCarteVitale?.benef?.length) {
                    const e = this.enumCarteVitale;
                    for (let i = 0; i < this.getCarteVitale.benef.length; i++) {
                        const b = this.getCarteVitale.benef[i];
                        if (b?.FieldsCount > 0) {
                            const nom = b.Fields?.[e.VITALE_NOM_USUEL] ?? '';
                            const prenom = b.Fields?.[e.VITALE_PRENOM] ?? '';
                            const rawDate = b.Fields?.[e.VITALE_DATE_NAISSANCE] ?? '';
                            list.push(this.normalizeBenefFromCV(b, i, nom, prenom, rawDate));
                        }
                    }
                }
                if (!list.length) {
                    for (let i = 0; i < this.lesBeneficiares.length; i++) {
                        const b = this.lesBeneficiares[i];
                        list.push(this.normalizeBenefFromDemo(b, i));
                    }
                }
                return list;
            },
            nomPrenom() {
                //console.log("this.getCarteCPS = ", this.getCarteCPS)
                //alert("Dans nomPrenom");
                //if (!this.getCarteCPS || this.getCarteCPS.length < 1) return "";
                //const fieldsGroup1 = this.getCarteCPS.find(item => item.group === 1)?.fields || [];
                //// Nom brut = "DODO0067688", Prénom = "ALAIN"
                //const nomBrut = fieldsGroup1[5] || "";
                //const prenom = fieldsGroup1[6] || "";
                //// Nettoyage du nom pour enlever les chiffres (garde uniquement lettres)
                //const nom = nomBrut.replace(/[0-9]/g, "");
                //return `${nom} ${prenom}`.trim();
                const cps = this.getCarteCPS;
                let fields = null;
                if (Array.isArray(cps)) {
                    const g = cps.find(x => x?.group === 1 || x?.Type === 1) || cps[0];
                    fields = g?.Fields;
                } else if (cps && cps.Fields) {
                    fields = cps.Fields;
                }
                if (fields?.length > 6) {
                    const nom = String(fields[5] ?? '').replace(/[0-9]/g, '').trim();
                    const prenom = String(fields[6] ?? '').trim();
                    const complet = `${nom} ${prenom}`.trim();
                    if (complet) return complet;
                }
                // Repli sur le praticien en BASE (connexion identifiant/mot de passe, sans CPS).
                const pb = this.$store.getters['ConnexionStore/getPraticien'];
                if (pb && (pb.nom || pb.prenom)) {
                    return `${pb.nom ?? ''} ${pb.prenom ?? ''}`.trim();
                }
                return "";
            },

            cabinet() {
                const s = this.$store.getters['Cartes/getSituationChoisie'];
                if (!s) return "";
                const struct = champ(s, CPS_RAISON_SOCIALE_STRUCTURE);
                const ident = champ(s, CPS_IDENT_FACTURATION);
                return [struct, ident].filter(Boolean).join(' — ');
            },
            formsoin() {
                return this.store.getters["Formsoin/getFormsoin"]
            },
            filteredOptions() {
                const escapeRegExp = (string) => {
                    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                };

                return this.searchFilter.map((filter) => {
                    const escapedSearchFilter = escapeRegExp(filter);
                    const regOption = new RegExp(`\\b${escapedSearchFilter}`, 'ig');
                    return this.options.filter((option) =>
                        filter.length < 1 || option.Libelle.match(regOption)
                    );
                });
            }
        },

        methods: {
            // === PARCOURS DE SOINS ===
            // Contexte envoye au backend (etat des cases MT + AME/AT/date).
            parcoursCtx() {
                return {
                    valeurActuelle: this.selectedParcours || '',
                    jeSuisMedecinTraitant: this.jeMt,
                    autreMedecinTraitant: this.autreMt,
                    aucunMedecinTraitant: this.aucunMt,
                    enAME: false,
                    regimeAccident: '',
                    dateFse: ''
                };
            },
            // Les 3 cases sont exclusives ; un changement recharge les options.
            onMtChange(quel) {
                if (quel === 'je') { if (this.jeMt) { this.autreMt = false; this.aucunMt = false; } }
                else if (quel === 'autre') { if (this.autreMt) { this.jeMt = false; this.aucunMt = false; } }
                else if (quel === 'aucun') { if (this.aucunMt) { this.jeMt = false; this.autreMt = false; } }
                this.rechargerParcours();
            },
            // Recupere les options reelles depuis le backend (selon patient/actes/specialite).
            async rechargerParcours() {
                try {
                    const res = await ParcoursDeSoin.getOptions(this.parcoursCtx());
                    const opts = (res && (res.options ?? res.Options)) || [];
                    this.parcours = opts;
                    const def = (res && (res.defaut ?? res.Defaut)) || '';
                    if (def && opts.includes(def)) this.selectedParcours = def;
                    else if (!opts.includes(this.selectedParcours)) this.selectedParcours = opts[0] || '';
                    await this.envoyerChoixParcours();
                } catch (e) {
                    console.error('Erreur chargement options parcours :', e);
                }
            },
            // Envoie le parcours choisi au backend (memorise + calcule topMT/IPS).
            async envoyerChoixParcours() {
                if (!this.selectedParcours) return;
                try {
                    await ParcoursDeSoin.setChoix({ ...this.parcoursCtx(), caption: this.selectedParcours });
                } catch (e) {
                    console.error('Erreur envoi choix parcours :', e);
                }
            },

            // === DATES ===
            /**
             * Retourne la date du jour au format ISO attendu par <input type="date"> : YYYY-MM-DD.
             * (Le navigateur affichera en JJ/MM/AAAA selon la locale, p.ex. fr-FR.)
             */
            normalizeBenefFromCV(b, idx, nom, prenom, rawDate) {
                return {
                    id: `cv-${idx}`,
                    nom: nom || '—',
                    prenom: prenom || '—',
                    dateNaissance: this.formatDateMaybeRaw(rawDate),
                    source: 'carte vitale',
                    raw: b
                };
            },
            normalizeBenefFromDemo(b, idx) {
                return {
                    id: `ex-${idx}`,
                    nom: b.nom || '—',
                    prenom: b.prenom || '—',
                    dateNaissance: b.dateNaissance || '—',
                    source: 'exemple',
                    raw: b
                };
            },
            formatDateMaybeRaw(rawDate = '') {
                if (/^\d{8}$/.test(rawDate)) {
                    const an = rawDate.slice(0, 4);
                    const mo = rawDate.slice(4, 6);
                    const jo = rawDate.slice(6, 8);
                    return `${jo}/${mo}/${an}`;
                }
                return rawDate || '—';
            },
            getTodayISO() {
                const d = new Date();
                const y = d.getFullYear();
                const m = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                return `${y}-${m}-${day}`;
            },
            // Date du jour au format FR (JJ/MM/AAAA) pour la saisie masquee (v-date-fr).
            getTodayFR() {
                const d = new Date();
                const day = String(d.getDate()).padStart(2, '0');
                const m = String(d.getMonth() + 1).padStart(2, '0');
                return `${day}/${m}/${d.getFullYear()}`;
            },
            ...mapActions("FSEHandler", ["fetchFacfse", "setFacfse"]),
            fse() {
                this.$router.push('/Fse');
            },
            enregistrer() {
                this.$store.dispatch("FSEHandler/enregistrerFse");
            },

            affichePatient() {
                console.log('Le span patient a été cliqué !');
                this.isPressed = !this.isPressed;
                this.isPressed2 = false;
                document.getElementById('option-details-regime-fse').style.display = 'none';
                this.isPressed3 = false;
                document.getElementById('option-details-facture-fse').style.display = 'none';
                this.isPressed5 = false;
                document.getElementById('option-details-divers-fse').style.display = 'none';
                this.isPressed4 = false;
                document.getElementById('option-details-praticien-fse').style.display = 'none';
                let patient = document.getElementById('option-details-patient-fse')

                if (patient.style.display == 'block') {
                    patient.style.display = 'none'
                } else {
                    patient.style.display = 'block'

                }
            },

            afficheRegime() {
                console.log('Le span regime a été cliqué !');
                this.isPressed = false;
                document.getElementById('option-details-patient-fse').style.display = 'none';
                this.isPressed2 = !this.isPressed2;
                document.getElementById('option-details-divers-fse').style.display = 'none';
                this.isPressed4 = false;
                document.getElementById('option-details-facture-fse').style.display = 'none';
                this.isPressed5 = false;
                this.isPressed3 = false;

                let regime = document.getElementById('option-details-regime-fse')

                if (regime.style.display == 'block') {
                    regime.style.display = 'none'
                } else {
                    regime.style.display = 'block'
                }
            },

            afficheDivers() {
                console.log('Le span divers a été cliqué !');
                this.isPressed = false;
                document.getElementById('option-details-patient-fse').style.display = 'none';
                this.isPressed2 = false;
                document.getElementById('option-details-regime-fse').style.display = 'none';
                this.isPressed4 = false;
                document.getElementById('option-details-praticien-fse').style.display = 'none';
                document.getElementById('option-details-facture-fse').style.display = 'none';
                this.isPressed5 = false;
                this.isPressed3 = !this.isPressed3;

                let divers = document.getElementById('option-details-divers-fse');

                if (divers.style.display == 'block') {
                    divers.style.display = 'none';
                } else {
                    divers.style.display = 'block';
                }
            },

            afficheFacture() {
                this.isPressed = false;
                document.getElementById('option-details-patient-fse').style.display = 'none';
                this.isPressed2 = false;
                document.getElementById('option-details-regime-fse').style.display = 'none';
                document.getElementById('option-details-divers-fse').style.display = 'none';
                this.isPressed3 = false;
                this.isPressed4 = false;
                document.getElementById('option-details-praticien-fse').style.display = 'none';
                this.isPressed5 = !this.isPressed5;

                let facture = document.getElementById('option-details-facture-fse')

                if (facture.style.display == 'block') {
                    facture.style.display = 'none';
                } else {
                    facture.style.display = 'block';
                }
            },

            checkMaternite() {
                let divers = document.getElementById('container-divers-maternite');
                let checkbox = document.getElementById("maternite-checkbox-fse");
                let checkbox2 = document.getElementById("maternite-checkbox2-fse");

                if (divers.style.display == 'block') {
                    divers.style.display = 'none';
                    document.getElementById('maternite-check-fse').style.display = 'block';
                    checkbox.checked = false;
                } else {
                    divers.style.display = 'block';
                    document.getElementById('maternite-check-fse').style.display = 'none';
                    checkbox2.checked = true;
                }
            },

            afficheToutDivers() {
                document.getElementById('option-details-patient-fse').style.display = 'block';
                document.getElementById('option-details-regime-fse').style.display = 'block';
                document.getElementById('option-details-divers-fse').style.display = 'block';
            },

            affichePraticien() {
                console.log('Le span praticien a été cliqué !');
                this.isPressed = false;
                document.getElementById('option-details-patient-fse').style.display = 'none';
                this.isPressed2 = false;
                document.getElementById('option-details-regime-fse').style.display = 'none';
                this.isPressed3 = false;
                document.getElementById('option-details-facture-fse').style.display = 'none';
                this.isPressed5 = false;
                document.getElementById('option-details-divers-fse').style.display = 'none';
                this.isPressed4 = !this.isPressed4;

                let praticien = document.getElementById('option-details-praticien-fse')

                if (praticien.style.display == 'block') {
                    praticien.style.display = 'none';
                } else {
                    praticien.style.display = 'block';
                }
            },

            incrNombreDActe() {
                // Numéro de l'acte
                this.nombreDActes.push(this.nombreDActes.length + 1);

                // Date du nouvel acte = date du précédent (ou aujourd'hui si absent)
                const lastDate = this.dateSaisie[this.dateSaisie.length - 1] || this.getTodayFR();
                this.dateSaisie.push(lastDate);

                // Champs associés
                this.searchFilter.push('');
                this.optionsShown.push(false);
                this.isSuccessful.push(false);
                this.highlightedOption.push(-1);
                this.selected.push({});
            },

            decrNombreDActe(indexToRemove) {
                this.nombreDActes.splice(indexToRemove, 1);
                this.dateSaisie.splice(indexToRemove, 1);
                this.searchFilter.splice(indexToRemove, 1);
                this.optionsShown.splice(indexToRemove, 1);
                this.isSuccessful.splice(indexToRemove, 1);
                this.highlightedOption.splice(indexToRemove, 1);
                this.selected.splice(indexToRemove, 1);
            },

            selectOption(option, index) {
                this.selected[index] = option;
                this.optionsShown[index] = false;
                this.searchFilter[index] = option.Libelle;
            },

            showOptions(index) {
                this.optionsShown[index] = true;
                this.highlightedOption[index] = -1;
            },

            exit(index) {
                this.optionsShown[index] = false;
                this.highlightedOption[index] = -1;
            },

            async keyMonitor(event, index) {
                if (event.key === "Enter") {
                    if (this.highlightedOption[index] >= 0 && this.filteredOptions[index][this.highlightedOption[index]]) {
                        this.selectOption(this.filteredOptions[index][this.highlightedOption[index]], index);
                    } else if (this.filteredOptions[index][0]) {
                        this.selectOption(this.filteredOptions[index][0], index);
                    } else {
                        alert("No option available");
                    }
                } else if (event.key === "ArrowDown") {
                    if (this.highlightedOption[index] < this.filteredOptions[index].length - 1) {
                        this.highlightedOption[index]++;
                    }
                } else if (event.key === "ArrowUp") {
                    if (this.highlightedOption[index] > 0) {
                        this.highlightedOption[index]--;
                    }
                } else {
                    this.optionsShown[index] = true;
                }
                for (let i = 0; i < this.searchFilter.length;i++) {
                    this.getFacfse.prest[i+1].presta_Renamed = this.searchFilter[i]
                }
                console.log(this.getFacfse);
                await this.setFacfse(this.getFacfse);
            },

            filterInput(event, inputName) {
                this[inputName] = event.target.value.replace(/\D/g, '');
            },

            calculateMontantTotal() {
                this.montantTotal = this.selected.reduce((total, select) => {
                    if (select && select.Montant) {
                        const montant = parseFloat(select.Montant.replace(',', '.'));
                        return total + (isNaN(montant) ? 0 : montant);
                    }
                    return total;
                }, 0);
            },

            isActExist(codeAct, date, index) {
                //var url = "https://localhost:44328/Actes/getIsActExist";
                var url = `${config.urlBackEnd}Actes/getIsActExist`;
                RequestManager.post(url, {
                    "codeActe": codeAct
                })
                    .then(response => {
                        this.isSuccessful[index] = response;
                        console.log("isAcExist", response)
                    })
                    .catch(error => {
                        console.error('Erreur lors de la verification de l\'existence de l\'acte dans la backend :', error);
                    });
            },
            loadFormSoin() {
                console.log("formsoin = ", Formsoin.getFormSoin());
                this.$store.dispatch("FormStore/initFormsoin")
            },
        },

        created() {
            // Initialise la date du 1er acte à aujourd'hui si vide
            if (!this.dateSaisie[0]) {
                this.dateSaisie[0] = this.getTodayFR();
            }
        },

        async mounted() {
            const url1 = `${config.urlBackEnd}Actes/getCCAM`;
            RequestManager.get(url1)
                .then(response => {
                    this.options = response;
                    console.log(response);
                })
                .catch(error => alert(error));
            this.$store.dispatch('FSEHandler/initParams')
            this.loadFormSoin();
            await this.fetchFacfse();
            // Charge les options de parcours reelles (selon patient/actes/specialite cote serveur).
            this.rechargerParcours();
        },

        watch: {
            searchFilter: {
                handler(newValues) {
                    newValues.forEach((filter, index) => {
                        if (this.filteredOptions[index].length > 0) {
                            this.isSuccessful[index] = (filter === this.filteredOptions[index][0].Libelle);
                            if (this.isSuccessful[index]) {
                                this.selectOption(this.filteredOptions[index][0], index);
                            }
                        } else {
                            this.isSuccessful[index] = false;
                            let date = this.dateSaisie[index] ? this.dateSaisie[index] : Date();
                            let bool = this.isActExist(filter, date, index);
                            this.isSuccessful[index] = bool;
                        }
                    });
                },
                deep: true
            },

            selected: {
                handler() {
                    this.calculateMontantTotal();
                },
                deep: true,
            }
        }
    });
</script>
